import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { AffiliatePartner } from './useAffiliatePartners';

interface TrackClickParams {
  partner: AffiliatePartner;
  referrer?: string;
}

export const useAffiliateClicks = () => {
  return useMutation({
    mutationFn: async ({ partner, referrer }: TrackClickParams) => {
      const { data: { user } } = await supabase.auth.getUser();

      const { error } = await supabase
        .from('affiliate_clicks')
        .insert({
          affiliate_partner_id: partner.id,
          partner_name: partner.partner_name,
          category: partner.category,
          affiliate_url: partner.affiliate_url,
          user_id: user?.id || null,
          user_agent: navigator.userAgent,
          referrer: referrer || document.referrer,
        });

      if (error) throw error;
    },
  });
};
